import { CheckCircleFilled, WarningFilled } from '@ant-design/icons';

/**
 * Confirmation shown to Office Practicum users immediately after a note is
 * pushed to the EHR. It confirms the submit succeeded AND warns them to
 * refresh their OP note before navigating away, because moving to another
 * chart section before refreshing can replace the AI note with the template.
 *
 * Designed to be rendered inside an antd Tooltip/Popover with a light
 * (white) surface. The hosting tooltip sets an explicit width so the copy
 * wraps predictably; keep this content fluid (w-full) so it fills it.
 */
const OPEhrSuccessMessage = () => {
  return (
    <div className="w-full text-left">
      <div className="flex items-center gap-2 px-3 py-2 bg-[#E6F7EF] rounded-md">
        <CheckCircleFilled style={{ color: '#0FA968', fontSize: 16 }} />
        <span className="text-[13px] font-semibold text-[#0FA968]">
          Submitted to EHR
        </span>
      </div>

      <div className="flex items-start gap-2 px-3 py-2 mt-2">
        <WarningFilled
          style={{
            color: '#F5A623',
            fontSize: 16,
            marginTop: 2,
            flexShrink: 0,
          }}
        />
        <div className="flex flex-col flex-1 min-w-0">
          <span className="block text-[13px] font-semibold text-[#1F2937] leading-snug">
            Refresh your OP note right away.
          </span>
          <span className="block text-[12px] text-[#6B7280] leading-snug mt-0.5 whitespace-normal break-words">
            Moving to another chart section before refreshing can replace the AI
            note with the template.
          </span>
        </div>
      </div>
    </div>
  );
};

export default OPEhrSuccessMessage;
